import React, { useState, useEffect, useMemo } from 'react';
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar';
import Svg from '../../../../../component/common/Svg';
import style from "../../../../style.module.css";

import { useDevice } from "../../../../customHooks";
import Card from '../../../../../core/Card';
import Typography from '../../../../../core/Typography';
import Input from "../../../../../core/Inputs/DefaultInput";
import { Link } from 'react-router-dom';
import ReactEcharts from "echarts-for-react";


export default function DesignThankyouPage(props) {
    const { view, color, pos, isOpen } = props;
    let device = useDevice();
    const flexDirection = device === "mobile" ? "column" : "row";
    const alignItems = device === "mobile" ? "flex-start" : "initial";



    //States
    const [isMobile, setIsMobile] = useState(false)

    //Colors
    const sectionColors = ['#9C2AA0', '#E60000', '#A8B400', '#EB9700', '#00B0CA', '#4A4D4E']

    //Options and style
    const style = {
        height: isMobile ? '300px' : '450px',
        width: '100%',
        // add the chart-container class
        className: 'chart-container',
    }

    const option = {


        radar: {
            // shape: 'circle',
            indicator: [
                { name: 'Sales', max: 6500 },
                { name: 'Administration', max: 16000 },
                { name: 'Information Technology', max: 30000 },
                { name: 'Customer Support', max: 38000 },
                { name: 'Development', max: 52000 },
                { name: 'Marketing', max: 25000 }
            ]
        },
        series: [
            {
                name: 'Budget vs spending',
                type: 'radar',
                data: [
                    {
                        value: [4200, 3000, 20000, 35000, 50000, 18000],
                        name: 'Allocated Budget'
                    },
                    {
                        value: [5000, 14000, 28000, 26000, 42000, 21000],
                        name: 'Actual Spending'
                    }
                ]
            }
        ]
    };




    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex">
                    <SurveyListSidebar />
                    <div id="content" className="flex-grow-1 dashboard-page-outer">
                        {/* <SubHeader /> */}
                        <div className="survey-design-container d-flex">
                            {/**New Sidebar Code */}
                            <div className="design-sidebar">
                                <div className="design-default-sidebar">

                                    <div className="side-tab-wrapper pt-0">
                                        {/* breadcrumbs here */}
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <Link to="/admin/survey/list">Survey</Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <a href="#">Survey Name</a>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <a href="#">Thankyou Pages</a>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <a href="#">Thankyou Page 1</a>
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    <strong>Customize</strong>
                                                </li>
                                            </ol>
                                        </nav>
                                        {/* breadcrumbs ends here */}
                                        <div className="gx-3 row">

                                            <div className="col-md-12">
                                                <div className="logo-edit">

                                                    <div className="text-small-gray">TEXT</div>
                                                    <div className="box-edit">
                                                        {/* <div class="panel-edit">
                                                            <div className="title-small-text mb-2">Title</div>
                                                            < Input
                                                                type='text'
                                                                view='outlined'
                                                                dense={false}
                                                                color='default'
                                                                label=''
                                                                placeholder='Title'
                                                                clearButton={true}
                                                                success={false}
                                                                error={false}
                                                                fill={true}
                                                                errorHelperText={null}
                                                                className={"formsinput"}
                                                            />
                                                        </div>

                                                        <div className="divider-edit" /> */}

                                                        <div class="panel-edit">
                                                            <div className="title-small-text mb-2">Description</div>
                                                            <textarea className="form-control" rows={3} defaultValue={""} />

                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <button className="btn btn-bordered  w-100 ">Cancel</button>
                                            </div>
                                            <div className="col-md-6">
                                                <button type="button" className="btn btn-primary add-btn  w-100" data-bs-toggle="modal" data-bs-target="#editPins" srno="1" value="1">Save & Apply</button>

                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>


                            {/**Right Bar Code */}
                            <div className='flex-grow-1'>


                                <>
                                    <div className='thank-you-page'>

                                        <div className="row">
                                            <div className="col-lg-6 mb-3 mb-lg-0">
                                                <div className="text-wrap">
                                                    <h1><span className='text-primary'>John Doe,</span> TCX Tech is at the <span className='text-primary'>‘Emerging’</span> stage</h1>
                                                    <p>Your personalised report is now available! Explore your insights and recommendations today. to help you transform your last mile delivery</p>
                                                    <div className="button-wrap d-flex flex-wrap">
                                                        <button className='btn btn-primary me-0 me-md-3 mb-3'> View report </button>
                                                        <button className='btn btn-transparent btn-icon mb-3'> Download report <Svg name="button-icon" /></button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="graph-box">
                                                    <div className="chart-wrapper">
                                                        <ReactEcharts style={style} option={option} />
                                                    </div>
                                                    <div className="value-wrapper">
                                                        <div className="value-box value-1">
                                                            <div className="number">2.1</div>
                                                            <div className="text">Business</div>
                                                        </div>
                                                        <div className="value-box value-2">
                                                            <div className="number">2.1</div>
                                                            <div className="text">Business</div>
                                                        </div>
                                                        <div className="value-box value-3">
                                                            <div className="number">2.1</div>
                                                            <div className="text">Business</div>
                                                        </div>
                                                        <div className="value-box value-4">
                                                            <div className="number">2.1</div>
                                                            <div className="text">Business</div>
                                                        </div>
                                                        <div className="value-box value-5">
                                                            <div className="number">2.1</div>
                                                            <div className="text">Business</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </>

                            </div>

                        </div>
                        <div className="customvar-modal modal fade edit-pop-modal save-design-popup" id="editPins" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className={"formcontainer" + " " + style.container}>
                                            <div className={"formvawrapper" + " " + style.wrapper}>
                                                <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                                    <Typography
                                                        type={device === "mobile" ? "h6" : "h5"}
                                                        colorStep={100}
                                                        tagName="div"
                                                        className={"formhead "}
                                                    >
                                                        Save your changes to this theme?
                                                    </Typography>

                                                    <div className="input_with_info ">
                                                        <Input
                                                            type="text"
                                                            view="outlined"
                                                            color="default"
                                                            label=""
                                                            // placeholder="Label"
                                                            placeholder={'Copy of rosebud'}
                                                            // value={}
                                                            fill
                                                            className={"formsinput themeName" + " " + style.card__exp}

                                                        />
                                                    </div>
                                                    <div className="button-wrap d-flex justify-content-end">
                                                        <button type="button" className="btn btn-bordered" data-bs-dismiss="modal">Discard</button>
                                                        <button type="button" className="btn btn-primary ms-3">Save changes</button>
                                                    </div>
                                                </Card>
                                            </div >

                                        </div >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="customvar-modal modal fade upload-file-modal" id="addFile" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className={"formcontainer" + " " + style.container}>
                                            <div className={"formvawrapper" + " " + style.wrapper}>
                                                <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                                    <div className="card-heading d-flex justify-content-between">
                                                        <h5>Upload logo </h5>
                                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                                    </div>
                                                    <div className="file-upload-box">
                                                        <div className="icon-wrap">
                                                            <Svg name="file-upload" />
                                                        </div>
                                                        <div className="button-wrap">
                                                            <button type="button" className="btn btn-primary">Upload</button>
                                                        </div>
                                                        <p>Supported files - <i>JPG, PNG, JPEG, SVG</i></p>
                                                    </div>
                                                </Card>
                                            </div >

                                        </div >
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="customvar-modal modal fade upload-file-modal" id="addBackground" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-body">
                                        <div className={"formcontainer" + " " + style.container}>
                                            <div className={"formvawrapper" + " " + style.wrapper}>
                                                <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                                    <div className="card-heading">
                                                        <h5>Upload Background image</h5>
                                                        <p>Note:- Image width should not be less than 1200px</p>
                                                    </div>
                                                    <div className="file-upload-box">
                                                        <div className="icon-wrap">
                                                            <Svg name="file-upload" />
                                                        </div>
                                                        <div className="button-wrap">
                                                            <button type="button" className="btn btn-primary">Upload</button>
                                                        </div>
                                                        <p>Supported files - <i>JPG, PNG, JPEG, SVG</i></p>
                                                    </div>
                                                </Card>
                                            </div >

                                        </div >
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}
